<app-loader></app-loader>

<form [formGroup]="loginform" (ngSubmit)="onSubmit()" class="loginFormPage">
      <div class="loginLogo">
                      <a [routerLink]="['/']" class="p-3">
                    <img src="../../assets/images/backend-image/login-page/logo.png" alt="Eazy Venue" height="100px" width="100px" />
                </a>
                </div>
    <div class="login-body">
        <div class="login-wrapper">
            <div class="login-panel">
              
                 <div class="alert alert-danger" role="alert" *ngIf="isLoginFailed">
                        Login failed: {{ errorMessage }}
                    </div>
                <div class="loginPageMainDiv">
                    <div class="ballIconleft">
                        <img src=".../../../../assets/images/backend-image/login-page/ball.png" alt="">
                    </div>
                    <div class="ballIconright">
                        <img src=".../../../../assets/images/backend-image/login-page/ball2.png" alt="">
                    </div>
                    <div class="box-div">
                        <div class="welcomeText">
                            <h3>Welcome to TPL</h3>
                            <p>Sign in to continue</p>
                        </div>
                        <div class="formDiv">
                            <div class="formField">
                                <div class="labelDiv">
                                    <h6>Email Id</h6>
                                </div>
                                <div class="inputDiv">
                                     <input pInputText id="email" formControlName="email" placeholder="Email" />
                                </div>
                            </div>
                            <div class="formField passwordField">
                                <div class="labelDiv">
                                    <h6>Password</h6>
                                </div>
                                <div class="inputDiv">
                                       <input pPassword id="password" type="password" formControlName="password" placeholder="Password" />
                                </div>
                            </div>
                            <div class="checkBoxdiv">
                                <div class="leftDiv">
                                    <input type="checkbox" />
                                    <p>Remember me</p>
                                </div>
                                <div class="rightDiv">
                                    <p>Forgot Password?</p>
                                </div>
                            </div>
                           
                          <div class="submitBtton">
                              <button pButton type="submit" label="Sign in" [disabled]="!loginform.valid"></button>
                          </div>
                        </div>
                    </div>
                </div>
              
             
                   
                

                <!-- <input pInputText id="email" formControlName="email" placeholder="Email" />
                <input pPassword id="password" type="password" formControlName="password" placeholder="Password" />

                <button pButton type="submit" label="LOGIN" [disabled]="!loginform.valid"></button> -->
                <!-- <a href="#">forgot password?</a>
                <p>Don’t you have an account, <a href="#">sign up</a></p> -->
            </div>
            <!-- <div class="login-footer">
                <h4>freya</h4>
                <h6>Copyright Ⓒ PrimeTek Informatics</h6>
            </div> -->
        </div>
    </div>
</form>